import { DeleteUserDialog } from './DeleteUser';
export default DeleteUserDialog;
